import * as R from 'ramda'
import tap from 'tap-logger'
import {conekta} from '../mixins/conekta'
import Pair from 'crocks/Pair'
import {numberFilters} from '../mixins/number-filters'
import {prefillCheckoutData} from '../helpers/testing-helpers'

const {parseMoney}  = numberFilters.filters

// validator :: {key: 'err_msg'} -> {key: val || undefined} -> ['err_msg']
const validate = (spec, obj) =>
  R.pipe(
    R.mapObjIndexed((msg, key) =>
        obj[key] === ''
        || obj[key] === undefined
           ? msg
           : undefined
   ),
    R.pickBy(v => v !== undefined),
    R.values
  )(spec)

const makeSpec = (keys, copies) => R.pipe(
	R.map(key => ({ [key] : copies[key] || `Hubo un error en el campo ${key}` })),
	R.mergeAll,
)(keys)


const formatMoney = R.pipe(amount => amount/100, parseMoney)

// calculateTotal :: Number -> Number -> Number -> {free_shipping, value} -> Number
const calculateTotal = (maxForFreeShipping, subtotal, shipping, discount) => R.pipe(
  discount => subtotal + discount.value,
  totalWithoutShipping => totalWithoutShipping > maxForFreeShipping || discount.free_shipping
    ? Pair(
		discount.value - shipping, /*restamos shipping porque discount es un numero negativo*/
		totalWithoutShipping
	)
    : Pair(
		discount.value,
		totalWithoutShipping + shipping
	),
  discountAndTotal => discountAndTotal.map(total => total > 0 ? total : 0),//Pair.map mapea sobre el segundo valor
)(discount)


export const checkout = {
	el: '#checkout-vue',
	mixins: [conekta],
	ready() {
		if(process.env.NODE_ENV !== 'prod') {
			window.prefillCheckoutData = () => prefillCheckoutData(this.$data)
		}
	},
	data: {
		checkout_form: 'checkout_form',
		first_name: '',
		last_name: '',
		country: '',
		state: '',
		street_1: '',
		street_2: '',
		street_3: '',
		city: '',
		zip_code: '',
		phone: '',
		email: '',
		references: '',
		//payment_method
		payment_method: '',
		//card
		credit_card: {
			number: '',
			name: '',
			exp_month: '',
			exp_year: '',
			cvc: '',
		},
		//spei
		spei: false,
		//paypal
		paypal: false,
		//Discount Code
		discount_code: '',
		//terms accepted
		terms_accepted: false,
		//shipping data
		shippingData: 0	,
		shippingDataCache: {},
        //address
		selectedAddress: null,//Null | Int | 'new_address'
		selectedCard: null//Null | Int | 'new_card'
		// selectedAddress: '',//Null | Int | 'new_address'
		// selectedCard: ''//Null | Int | 'new_card'

	},

	watch: {
		payment_method() {
			if(this.payment_method !== 'conekta_card') {
				this.selectedCard = null
			}else if(this.userCards.length === 0){
				this.selectedCard = 'new_card'
			}
		},
		userAddresses: {
			immediate: true,
			handler() {
				if(this.userAddresses.length === 0) {
					this.selectedAddress = 'new_address'
				}
			}
		},
        userCards: {
			immediate: true,
			handler() {
				if(this.userCards.length === 0) {
					this.selectedCard = 'new_card'
				}
			}
		},
	},

	computed: {
		copies() {
			return this.$root.store.copies.checkout
		},

		items() {
			return R.pipe(
				R.pathOr([], ['store', 'cart', 'data', 'items'])
			)(this)
		},

		shippingCost() {
			return  R.pathOr(0, ['shippingData', 'value'], this)
		},

		//discountAndTotal :: crocks.Pair
		discountAndTotal() {
			return calculateTotal(
				R.pathOr(Infinity, ['store', 'min_to_free_shipping'], this),
				R.pathOr(0, ['store', 'cart', 'data', 'subtotal'], this),
				this.shippingCost,
				R.path(['store', 'discount'], this),
			)
		},

		discount() {
			return this.discountAndTotal.fst()
		},

		total() {
			return this.discountAndTotal.snd()
		},

		subtotal() {
			return R.pathOr(0,
				['store', 'cart', 'data', 'subtotal'],
				this
			)
		},

		userAddresses() {
			return R.pipe(
				R.pathOr([], ['store', 'current_user', 'addresses']),
				R.map(a => ({
					id: a.id,
					name: a.label
				}))
			)(this)
		},

		userCards() {
			return R.pipe(
				R.pathOr([], ['store', 'current_user', 'cards']),
				R.map(c => ({
					id: c.token,
					digits: c.label
				}))
			)(this)
        },

		states() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.keys
			)(this)
		},

		municipalities() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.pathOr([], [this.state]),
				R.map(R.prop('NOM_MUN'))
			)(this)
		},

        countries(){
			return R.pipe(
				R.pathOr([], ['store', 'countries']),
			)(this)
        }
	},

	methods: {
		formatMoney,

		postShippingAddress() {
			let url = this.$root.store.routes.shippment.post
			let spec = {
				first_name: 1,
				last_name: 1,
                phone: 1,
                email: 1,

				country: 1,
				state: 1,
				street_1: 1,
				street_2: 1,
				street_3: 1,
				city: 1,
				zip_code: 1,
                references:1,

                selectedAddress: 1,//para las direcciones previamente salvadas
			}

			let missingFields =  validate(spec, this.$data).length !== 0
			if(missingFields && this.selectedAddress === 'new_address') {return}

			let specKeys = R.pipe(
				R.keys,
				R.sort((a,b) => a > b ? -1 : 1)
			)(spec)

			let cacheKey = R.pipe(
				R.pick(specKeys),
				data => R.map(key => data[key], specKeys),
				R.join('_'),
			)(this.$data)

			if(this.shippingDataCache[cacheKey]) {
				this.shippingData = this.shippingDataCache[cacheKey]
				return
			}

			this.$http.post(url, {
				_token: this.store.csrf_token,
					other_shipment: this.selectedAddress === 'new_address' ? 1 : 0,
					shipment_id:	this.selectedAddress,
                    shipment: {
                        first_name: this.first_name,
                        last_name: this.last_name,
                        phone: this.phone,
                        email: this.email,

                        country_id: this.country,
                        state: this.state,
                        street_1: this.street_1,
                        street_2: this.street_2,
                        street_3: this.street_3,
                        city: this.city,
                        zip_code: this.zip_code,

                        references: this.references,
                    }

			})
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.shippingData = this.shippingDataCache[cacheKey] = body.data
				})
				.catch(this.$root.ajaxErrAlerting)

		},

		postDiscountCode() {
			if(this.discount_code === '') {
				this.alertError([this.copies.errors.discount_required])
				return
			}
			let url = R.replace(
				'__discount-code__',
				this.discount_code,
				this.$root.store.routes.discounts.post
			)

			this.$http.get(url, {
				// _token: this.$root.store.csrf_token
			})
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.discount = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		makePost() {
			let errors = [].concat(
				this.validateAddress(this.$data),
				this.validatePayment(this.credit_card),
				this.validateTerms(this.$data),
			)

			if(errors.length > 0) {
				this.alertError(errors)
				return
			}

			if (this.payment_method === 'conekta_card' && this.selectedCard === 'new_card') {
				this.conektaPost(this.credit_card)
			}else {
				this.postCheckout()
			}
		},

		postCheckout() {
			this.post(document.getElementById(this.checkout_form))
		},

		onCheckoutSuccess(body) {
			window.location = body.data.redirect_url
		},

		validateAddress($data) {
			if(this.selectedAddress === null) {//no se ha seleccionado nada
				return [this.copies.errors.empty_address]
			}

			if(this.selectedAddress !== 'new_address') {// se ha seleccionado un id
				return []
			}

			//se ha seleccionado new_address
			let spec = makeSpec([
				'first_name',
				'last_name',
				'country',
				'state',
				'street_1',
				'street_2',
				'street_3',
				'city',
				'zip_code',
				'phone',
				'email',
			], this.copies.errors)

			return validate(spec, $data)
		},

		validatePayment($data) {
			if(this.payment_method === '') {
				return [this.copies.errors.payment_method]
			}

			if(this.payment_method === 'conekta_card' && this.selectedCard === null) {
				return [this.copies.errors.empty_card]
			}

			if(this.payment_method === 'conekta_card' && this.selectedCard === 'new_card') {
				let spec = makeSpec([
					'number',
					'name',
					'exp_month',
					'exp_year',
					'cvc',
				], this.copies.errors)

				return validate(spec, $data)
			}

			return []
		},

		validateTerms() {
			if(this.terms_accepted === false) {
				return [this.copies.errors.terms_accepted]
			}
			return []
		},
	},

};
